import gql from 'graphql-tag';

export const ContentFragment = gql`
	fragment ActionButtonContentFragment on Content {
		id
		metadata {
			currentuser {
				favourited {
					isFavourite
					favouritedDate
				}
			}
		}
	}
`;
